var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"title":"Open Invoice","items":_vm.invoice,"loading":_vm.loading},on:{"reloadList":_vm.getOpenInvoice}})
}
var staticRenderFns = []

export { render, staticRenderFns }